/** 少於這個年數就不預測 —— 兩年的 P25/P75 等同最小/最大值，帶寬失去意義。 */
export const MIN_YEARS = 3;

/**
 * 預測最終住房率的區間。
 *
 *     預測 = 今年在手率 + 剩餘進帳率的 P25 / P50 / P75
 *
 * 用加法而非「除以完成度」：遠期完成度的分母只有幾間房，除下去會把噪音放大十幾倍，
 * 且訂單縮減會讓完成度超過 100% 而式子失效 (詳見設計文件的實測)。
 *
 * 不把上界夾在 100% —— 超賣與升等本來就會讓實際住用超過可售房數，夾住會讓
 * 「這天已經滿到滿出來」看起來只是「剛好滿」。
 */
export function projectFinal(item) {
  if (!item || (item.n_years || 0) < MIN_YEARS) return null;
  const { occ_now: occ, rem_p25: p25, rem_p50: p50, rem_p75: p75 } = item;
  if (p25 == null || p50 == null || p75 == null) return null;
  return { lo: occ + p25, mid: occ + p50, hi: occ + p75 };
}
